import React from 'react';

import { Lightbox, PageSidebar, PageTitle } from '../../../components';

import { FaCircleCheck, FaTent } from 'react-icons/fa6';

import { useLocation } from 'react-router-dom';



const AccoSingle = () => {

  // Get Accommodation details passed via router state
  const location = useLocation();
  const acco = location.state;

  const midIndex = Math.ceil(acco.facilities.length / 2); // Midpoint index to split the facilities array in half
  const firstHalf = acco.facilities.slice(0, midIndex); // First half of the facilities array
  const secondHalf = acco.facilities.slice(midIndex); // Second half of the facilities array

  return (
    <>
      {/* Page Title Section */}
      <PageTitle title={acco.title} page={"Accommodation Single"} />

      <section className='acco-single page-single'>

        <div className='acco-info page-info'>

          {/* Accommodation Image */}
          <div className='image'>
            <img src={acco.image} alt={acco.title} />
          </div>

          <div className='content'>

            {/* Accommodation Title */}
            <h3 className='main-heading'>{acco.title}</h3>

            {/* Accommodation Description */}
            {acco.paragraphs.map((paragraph, index) => (
              <p key={index} className={index === 0 ? 'important' : ''}>
                {paragraph}
              </p>
            ))}

            {/* Accommodation Image Gallery */}
            <Lightbox images={acco.gallery} />

            {/* Accommodation Features Section */}
            <div className='sub-section'>

              <h3 className='sub-heading'>Room Types and Features:</h3>

              <p>Explore a variety of room types and enjoy features designed for comfort and convenience:</p>

              {/* List of Accommodation Features */}
              <ul>
                {acco.features.map((feature, index) => {
                  return <li key={index}><FaTent className='icon' />{feature}</li>
                })}
              </ul>

            </div>

            {/* Accommodation Facilities Section */}
            <div className='sub-section'>

              <h3 className='sub-heading'>Facilities and Amenities:</h3>

              <p>Enjoy a range of modern facilities and thoughtful amenities designed for a relaxing stay:</p>

              {/*Accommodation Facilities List */}
              <div className='box-container'>
                <ul>
                  {firstHalf.map((facility, index) => (
                    <li key={index}><FaCircleCheck className='icon' />{facility}</li>
                  ))}
                </ul>
                <ul>
                  {secondHalf.map((facility, index) => (
                    <li key={index}><FaCircleCheck className='icon' />{facility}</li>
                  ))}
                </ul>
              </div>

            </div>

          </div>

        </div>

        {/* Sidebar with Accommodation details */}
        <PageSidebar
          heading={'Accommodation'}
          details={acco.details}
          button={{ link: 'Booking', title: 'Book Now' }}
        />

      </section>

    </> 
  );
}

export default AccoSingle;